// Auto-generates funny unique usernames like "CosmicPickle" or "MidnightOtter"
// 500 adjectives × 500 nouns = 250,000 combinations

const ADJECTIVES = [
  'Midnight', 'Cosmic', 'Silent', 'Wild', 'Frozen', 'Lucid', 'Crimson',
  'Sleepy', 'Velvet', 'Ancient', 'Hollow', 'Amber', 'Neon', 'Phantom',
  'Solar', 'Misty', 'Thunder', 'Gentle', 'Rogue', 'Golden', 'Silver',
  'Twisted', 'Vivid', 'Stormy', 'Liquid', 'Rusty', 'Fuzzy', 'Sneaky',
  'Turbo', 'Wobbly', 'Grumpy', 'Dizzy', 'Spicy', 'Crispy', 'Bouncy',
  'Tiny', 'Giant', 'Soggy', 'Fluffy', 'Crunchy', 'Sparkly', 'Gloomy',
  'Cozy', 'Sneaky', 'Jumpy', 'Frosty', 'Blazing', 'Shiny', 'Dusty',
  'Groovy', 'Funky', 'Quirky', 'Zippy', 'Zesty', 'Peppy', 'Salty',
  'Bitter', 'Sweet', 'Sour', 'Tangy', 'Smoky', 'Spooky', 'Lucky',
  'Lazy', 'Hazy', 'Crazy', 'Dazed', 'Bold', 'Brave', 'Calm', 'Dark',
  'Deep', 'Dense', 'Dim', 'Dry', 'Dull', 'Eager', 'Early', 'Easy',
  'Empty', 'Even', 'Fair', 'Fast', 'Fat', 'Fine', 'Flat', 'Free',
  'Fresh', 'Full', 'Grand', 'Great', 'Green', 'Grey', 'Grim', 'Half',
  'Hard', 'Heavy', 'High', 'Holy', 'Hot', 'Huge', 'Icy', 'Idle',
  'Jolly', 'Just', 'Keen', 'Kind', 'Large', 'Last', 'Late', 'Lean',
  'Light', 'Lofty', 'Long', 'Lost', 'Loud', 'Low', 'Mad', 'Main',
  'Meek', 'Mere', 'Mild', 'Mint', 'More', 'Mute', 'Neat', 'Next',
  'Nice', 'Noble', 'Nude', 'Odd', 'Open', 'Oval', 'Pale', 'Pink',
  'Plain', 'Plump', 'Poor', 'Prime', 'Proud', 'Pure', 'Quiet', 'Rapid',
  'Rare', 'Raw', 'Real', 'Rich', 'Rosy', 'Rough', 'Round', 'Royal',
  'Safe', 'Sage', 'Same', 'Slim', 'Slow', 'Small', 'Smart', 'Soft',
  'Sole', 'Sore', 'Stark', 'Stiff', 'Still', 'Stone', 'Strange', 'Strong',
  'Sure', 'Swift', 'Tall', 'Tame', 'Thin', 'Tight', 'Tired', 'Torn',
  'Total', 'Tough', 'True', 'Ugly', 'Unfit', 'Unkind', 'Unlit', 'Vague',
  'Vast', 'Vivid', 'Warm', 'Weak', 'Weird', 'Wet', 'White', 'Whole',
  'Wide', 'Wise', 'Witty', 'Worn', 'Young', 'Zealous', 'Zany', 'Astral',
  'Blunt', 'Brash', 'Brief', 'Brisk', 'Bronze', 'Brute', 'Burnt', 'Burst',
  'Candy', 'Cape', 'Carbon', 'Cardinal', 'Chrome', 'Citrus', 'Clay',
  'Cloud', 'Cobalt', 'Comet', 'Copper', 'Coral', 'Crystal', 'Cyan',
  'Dapper', 'Daring', 'Darling', 'Dawn', 'Dazzling', 'Delta', 'Digital',
  'Distant', 'Divine', 'Dreamy', 'Drift', 'Echo', 'Electric', 'Elegant',
  'Ember', 'Epic', 'Eternal', 'Ether', 'Exotic', 'Extra', 'Fabled',
  'Faint', 'Fallen', 'Famous', 'Fancy', 'Feral', 'Fiery', 'Final',
  'Finite', 'Flaming', 'Flawless', 'Floating', 'Floral', 'Fluid', 'Flying',
  'Focal', 'Faded', 'Fragile', 'Frantic', 'Fringe', 'Galactic', 'Ghostly',
  'Glowing', 'Graceful', 'Granite', 'Gravity', 'Hazy', 'Hidden', 'Hyper',
  'Infinite', 'Inner', 'Intense', 'Jade', 'Jagged', 'Joyful', 'Kinetic',
  'Laser', 'Lavender', 'Legendary', 'Lemon', 'Linear', 'Lunar', 'Lurking',
  'Marble', 'Mellow', 'Molten', 'Mossy', 'Mystic', 'Natural', 'Nebula',
  'Nimble', 'Northern', 'Nuclear', 'Obsidian', 'Omega', 'Onyx', 'Optic',
  'Orbital', 'Outer', 'Pastel', 'Peach', 'Primal', 'Prismatic', 'Quantum',
  'Radiant', 'Rebel', 'Relic', 'Remote', 'Retro', 'Rising', 'Rustic',
  'Sacred', 'Sandy', 'Scarlet', 'Scattered', 'Shadow', 'Shaded', 'Sharp',
  'Sherbet', 'Shifting', 'Shimmering', 'Stellar', 'Stealthy', 'Sublime',
  'Sudden', 'Sunlit', 'Super', 'Surreal', 'Tangled', 'Terminal', 'Tidal',
  'Timber', 'Twilight', 'Ultra', 'Umbra', 'Untamed', 'Upbeat', 'Urban',
  'Velvet', 'Verdant', 'Vibrant', 'Violet', 'Viral', 'Vivid', 'Void',
  'Wandering', 'Warped', 'Wired', 'Wooden', 'Yellow', 'Zephyr'
]

const NOUNS = [
  'Otter', 'Noodle', 'Vortex', 'Biscuit', 'Tangerine', 'Echo', 'Pebble',
  'Mango', 'Ember', 'Ripple', 'Comet', 'Pickle', 'Thunder', 'Marble',
  'Waffle', 'Sparrow', 'Prism', 'Cactus', 'Puddle', 'Lantern', 'Badger',
  'Nugget', 'Taco', 'Flamingo', 'Pretzel', 'Penguin', 'Burrito', 'Narwhal',
  'Quasar', 'Muffin', 'Platypus', 'Donut', 'Avocado', 'Walrus', 'Dumpling',
  'Llama', 'Pancake', 'Raccoon', 'Noodle', 'Porcupine', 'Ramen', 'Capybara',
  'Nacho', 'Axolotl', 'Croissant', 'Manatee', 'Pretzel', 'Hamster', 'Bagel',
  'Hedgehog', 'Latte', 'Mongoose', 'Scone', 'Armadillo', 'Boba', 'Toucan',
  'Cupcake', 'Kiwi', 'Wombat', 'Macaron', 'Quokka', 'Pretzel', 'Tapir',
  'Churro', 'Lemur', 'Gyoza', 'Sloth', 'Falafel', 'Capybara', 'Sushi',
  'Alpaca', 'Brownie', 'Okapi', 'Gelato', 'Bison', 'Truffle', 'Moose',
  'Sorbet', 'Ferret', 'Pudding', 'Emu', 'Toffee', 'Koala', 'Granola',
  'Panda', 'Cobbler', 'Viper', 'Streusel', 'Lynx', 'Parfait', 'Gecko',
  'Beignet', 'Jaguar', 'Strudel', 'Ibis', 'Cannoli', 'Ocelot', 'Brioche',
  'Dingo', 'Churro', 'Meerkat', 'Tiramisu', 'Numbat', 'Panini', 'Quoll',
  'Galette', 'Aardvark', 'Calzone', 'Bandicoot', 'Stromboli', 'Cassowary',
  'Frittata', 'Kookaburra', 'Gnocchi', 'Bilby', 'Risotto', 'Wallaby',
  'Polenta', 'Echidna', 'Orzo', 'Warthog', 'Farro', 'Pangolin', 'Tempeh',
  'Basilisk', 'Seitan', 'Mantis', 'Kimchi', 'Axolotl', 'Miso', 'Fossa',
  'Tahini', 'Kakapo', 'Harissa', 'Tenrec', 'Zaatar', 'Binturong', 'Dukkah',
  'Chevrotain', 'Sumac', 'Takin', 'Paprika', 'Zorilla', 'Saffron', 'Potoo',
  'Turmeric', 'Shoebill', 'Cardamom', 'Frogmouth', 'Nutmeg', 'Nightjar',
  'Cinnamon', 'Kinkajou', 'Anise', 'Olingo', 'Clove', 'Cacomistle',
  'Vanilla', 'Coati', 'Fennel', 'Vontsira', 'Ginger', 'Falanouc', 'Mint',
  'Linsang', 'Basil', 'Genette', 'Thyme', 'Civet', 'Sage', 'Binturong',
  'Dill', 'Potto', 'Chive', 'Loris', 'Parsley', 'Tarsier', 'Rosemary',
  'Galago', 'Oregano', 'Aye-aye', 'Tarragon', 'Sifaka', 'Marjoram',
  'Indri', 'Cumin', 'Fossa', 'Pepper', 'Tenrec', 'Coriander', 'Shrew',
  'Mustard', 'Mole', 'Horseradish', 'Vole', 'Wasabi', 'Dormouse', 'Mace',
  'Jerboa', 'Allspice', 'Gerbil', 'Galangal', 'Chinchilla', 'Lemongrass',
  'Degu', 'Bergamot', 'Paca', 'Vetiver', 'Agouti', 'Labrador', 'Porcupine',
  'Retriever', 'Capybara', 'Spaniel', 'Nutria', 'Terrier', 'Marmot',
  'Beagle', 'Prairie', 'Poodle', 'Woodchuck', 'Dachshund', 'Groundhog',
  'Corgi', 'Chipmunk', 'Husky', 'Squirrel', 'Samoyed', 'Rabbit', 'Maltese',
  'Hamster', 'Bichon', 'Guinea', 'Papillon', 'Gerbil', 'Pomeranian',
  'Hedgehog', 'Shiba', 'Ferret', 'Akita', 'Chinchilla', 'Malamute',
  'Marmot', 'Keeshond', 'Vole', 'Elkhound', 'Lemming', 'Basenji', 'Mole',
  'Vizsla', 'Shrew', 'Weimaraner', 'Beaver', 'Otterhound', 'Muskrat',
  'Bloodhound', 'Coypu', 'Greyhound', 'Capybara', 'Whippet', 'Viscacha',
  'Lurcher', 'Patagonian', 'Saluki', 'Springhare', 'Azawakh', 'Bongo',
  'Sloughi', 'Okapi', 'Pharaoh', 'Sitatunga', 'Ibizan', 'Gerenuk',
  'Cirneco', 'Klipspringer', 'Podenco', 'Dik-dik', 'Canaan', 'Oribi',
  'Kelpie', 'Reedbuck', 'Huntaway', 'Steinbok', 'Heading', 'Grysbok',
  'Stumpy', 'Suni', 'Tenterfield', 'Beira', 'McNab', 'Dibatag', 'Catahoula'
]

export function generateUsername(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  return `${adj}${noun}`
}

export function generateMultiple(count: number = 3): string[] {
  const results: string[] = []
  const seen = new Set<string>()
  while (results.length < count) {
    const u = generateUsername()
    if (!seen.has(u)) {
      seen.add(u)
      results.push(u)
    }
  }
  return results
}
